import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex" }

import { signoutUser } from '@/composables/auth';
import { RoutesNames } from '@/router/routesNames';
import { useUserStore } from '@/store/user';
import { ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import WhoAreYouDialog from '../onboarding/WhoAreYouDialog.vue';
import LanguageMenu from './LanguageMenu.vue';
import { isSmallDevice } from '@/utils/helpers';
import { useDisplay } from 'vuetify';
import { checkViewType } from '@/composables/auth';


export default /*#__PURE__*/_defineComponent({
  __name: 'SignupNavbar',
  setup(__props) {

const route = useRoute();
const router = useRouter();

const userStore = useUserStore();
const display = useDisplay();

const logo = ref('logo-color.svg');
const logoSize = ref('40');

if (isSmallDevice()) {
    logoSize.value = '40';
} else {
    if (
        route.name == RoutesNames.onboarding_step_1 ||
        route.name == RoutesNames.onboarding_step_2
    ) {
        logo.value = 'logo-color.svg';
        logoSize.value = '40';
    } else {
        logo.value = 'logo-color.svg';
        logoSize.value = '60';
    }
}

function handleButtonClick() {
    if (userStore.isLoggedIn) {
        signoutUser();
    } else {
        router.push({ name: RoutesNames.signIn });
    }
}

function getThemeColor() {
    return route.name !== RoutesNames.onboarding_start ? 'white' : 'transparent';
}

function goToHome() {
    // router.push({ name: RoutesNames.onboarding_start });
    checkViewType();
}

return (_ctx: any,_cache: any) => {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_divider = _resolveComponent("v-divider")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      style: {"height":"75px"},
      class: _normalizeClass(`d-flex align-center justify-space-between ${
                _unref(display).xs.value ? 'px-4' : 'px-16'
            }`)
    }, [
      _createElementVNode("div", {
        class: "cursor",
        onClick: goToHome
      }, [
        _createVNode(_component_v_img, {
          height: logoSize.value,
          width: logoSize.value,
          class: "my-auto",
          src: require(`@/assets/images/${logo.value}`)
        }, null, 8, ["height", "width", "src"])
      ]),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(LanguageMenu, {
          theme: getThemeColor(),
          showTitle: true
        }, null, 8, ["theme"]),
        _createVNode(_component_v_btn, {
          class: "font ml-6",
          flat: "",
          variant: _unref(userStore).isLoggedIn ? 'text' : 'flat',
          rounded: "pill",
          color: _unref(userStore).isLoggedIn ? 'title' : 'white',
          onClick: handleButtonClick
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(userStore).isLoggedIn ? _ctx.$t('exit') : _ctx.$t('sign_in')), 1)
          ]),
          _: 1
        }, 8, ["variant", "color"])
      ])
    ], 2),
    _createVNode(_component_v_divider),
    _createVNode(WhoAreYouDialog)
  ]))
}
}

})